import messageRingUrl from '@/assets/media/messageRing.mp3'
import notificationRingUrl from '@/assets/media/notification.mp3'

let soundAlertInstance: ReturnType<typeof createSoundAlertService>

function createSoundAlertService() {
    const messageAudio = new Audio(messageRingUrl)
    const notificationAudio = new Audio(notificationRingUrl)
    let unlocked = false

    const unlockOne = (audio: HTMLAudioElement) => {
        audio.volume = 0
        return audio.play().then(() => {
            audio.pause()
            audio.currentTime = 0
            audio.volume = 1
        }).catch(() => {})
    }

    const unlock = () => {
        if (unlocked) return
        unlocked = true
        Promise.all([unlockOne(messageAudio), unlockOne(notificationAudio)])
    }

    document.addEventListener('click', unlock, { once: true })
    document.addEventListener('keydown', unlock, { once: true })

    const playMessageAlert = () => {
        if (document.hidden) return
        messageAudio.currentTime = 0
        messageAudio.play().catch(err => console.warn('Ошибка проигрывания звука пришедшего сообщения:', err))
    }

    const playNotificationAlert = () => {
        if (document.hidden) return
        notificationAudio.currentTime = 0
        notificationAudio.play().catch(err => console.warn('Ошибка проигрывания звука уведомления:', err))
    }

    return { playMessageAlert, playNotificationAlert }
}

export function useSoundAlert() {
    if (!soundAlertInstance) {
        soundAlertInstance = createSoundAlertService()
    }
    return soundAlertInstance
}
